import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyCd1GjVX7hJRgXQrErOZ-KoV6K4a-373do",
  authDomain: "disaster-kominfo.firebaseapp.com",
  projectId: "disaster-kominfo",
  storageBucket: "disaster-kominfo.appspot.com",
  messagingSenderId: "351950993651",
  appId: "1:351950993651:web:1089a0bcc523d95d8b1f86"
}

if (!firebase.apps.length) { 
  firebase.initializeApp(config)
}

export default (ctx, inject) => {
  inject('firebase', firebase)
}